import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSEO } from "../context/SEOContext";
import {
  SITE_LOCALE,
  SITE_NAME,
  buildOrganizationSchema,
  buildWebsiteSchema,
  getRouteSeo,
} from "../config/seo";

export default function SEOManager() {
  const { categoryName } = useSEO();
  const location = useLocation();
  const seo = getRouteSeo({
    pathname: location.pathname,
    search: location.search,
    categoryName,
  });

  return (
    <Helmet prioritizeSeoTags>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots} />
      <link rel="canonical" href={seo.canonicalUrl} />

      <meta property="og:locale" content={SITE_LOCALE} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={seo.ogType} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.canonicalUrl} />
      <meta property="og:image" content={seo.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      <script type="application/ld+json">
        {JSON.stringify(buildOrganizationSchema())}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(buildWebsiteSchema())}
      </script>
    </Helmet>
  );
}
